import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { fr } from "./fr";
import { en } from "./en";
import { nl } from "./nl";

export type Lang = "fr" | "en" | "nl";
export const LANGS: Lang[] = ["fr", "en", "nl"];

if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: { fr: { t: fr }, en: { t: en }, nl: { t: nl } },
      fallbackLng: "fr",
      defaultNS: "t",
      supportedLngs: LANGS,
      interpolation: { escapeValue: false },
      detection: {
        order: ["path", "localStorage", "navigator"],
        lookupLocalStorage: "2am-lang",
        caches: ["localStorage"],
      },
    });
}

export default i18n;
